import { render, staticRenderFns } from "./Favori.vue?vue&type=template&id=54d51998&scoped=true&"
import script from "./Favori.vue?vue&type=script&lang=js&"
export * from "./Favori.vue?vue&type=script&lang=js&"
import style0 from "./Favori.vue?vue&type=style&index=0&id=54d51998&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d51998",
  null
  
)

export default component.exports